import { darken, Theme } from '@mui/material'

const classes = {
  list: { display: 'flex', flexDirection: 'column', gap: '12px', paddingY: '12px', flex: 1 },
  listItemButton: (theme: Theme) => ({
    borderRadius: '100px',
    '&.Mui-selected': { backgroundColor: theme.palette.secondary.light, '&:hover': { backgroundColor: darken(theme.palette.secondary.light, 0.02) } },
  }),
  listItemIcon: { minWidth: 0, marginRight: '12px' },
  badge: {
    '& .MuiBadge-dot': {
      top: '25%',
      right: '10%',
      minWidth: '6px',
      height: '6px',
    },
  },
  labelText: (selected: boolean) => ({
    fontWeight: selected ? '600' : '500',
  }),
}

export default classes
